// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { squareT16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-square-t': IconSquareT;
    }
}

/**
 * The icon component for the 'squareT' icon
 */
export class IconSquareT extends Icon {
    public constructor() {
        super(squareT16X16);
    }
}

registerIcon('icon-square-t', IconSquareT);
export const iconSquareTTag = 'nimble-icon-square-t';
